import { render, staticRenderFns } from "./vendor-integration-details-flyout.vue?vue&type=template&id=dd9c3310&scoped=true&"
import script from "./vendor-integration-details-flyout.vue?vue&type=script&lang=js&"
export * from "./vendor-integration-details-flyout.vue?vue&type=script&lang=js&"
import style0 from "./vendor-integration-details-flyout.vue?vue&type=style&index=0&id=dd9c3310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9c3310",
  null
  
)

export default component.exports